import activity from '../../../assets/icons/activity.svg';
import addcomment from '../../../assets/icons/addcomment.svg';
import addcomment2 from '../../../assets/icons/addcomment2.svg';
import addfat from '../../../assets/icons/addfat.svg';
import addfolder from '../../../assets/icons/addfolder.svg';
import addons from '../../../assets/icons/addons.svg';
import addthin from '../../../assets/icons/addthin.svg';
import admin from '../../../assets/icons/admin.svg';
import adobe from '../../../assets/icons/adobe.svg';
import alert from '../../../assets/icons/alert.svg';
import aligncenter from '../../../assets/icons/aligncenter.svg';
import alignjustified from '../../../assets/icons/alignjustified.svg';
import alignleft from '../../../assets/icons/alignleft.svg';
import alignright from '../../../assets/icons/alignright.svg';
import animation from '../../../assets/icons/animation.svg';
import animationproject from '../../../assets/icons/animationproject.svg';
import apple from '../../../assets/icons/apple.svg';
import apps from '../../../assets/icons/apps.svg';
import archive from '../../../assets/icons/archive.svg';
import arrowdown from '../../../assets/icons/arrowdown.svg';
import arrowleft from '../../../assets/icons/arrowleft.svg';
import arrowright from '../../../assets/icons/arrowright.svg';
import arrowup from '../../../assets/icons/arrowup.svg';
import article from '../../../assets/icons/article.svg';
import aspectratio from '../../../assets/icons/aspectratio.svg';
import aspectshell from '../../../assets/icons/aspectshell.svg';
import at from '../../../assets/icons/at.svg';
import attachment from '../../../assets/icons/attachment.svg';
import audio from '../../../assets/icons/audio.svg';
import autocue from '../../../assets/icons/autocue.svg';
import autosave from '../../../assets/icons/autosave.svg';
import backhand from '../../../assets/icons/backhand.svg';
import beachaccess from '../../../assets/icons/beachaccess.svg';
import blockquote from '../../../assets/icons/blockquote.svg';
import bold from '../../../assets/icons/bold.svg';
import bookings from '../../../assets/icons/bookings.svg';
import bookingsdef from '../../../assets/icons/bookingsdef.svg';
import bookmark from '../../../assets/icons/bookmark.svg';
import bookmarkadd from '../../../assets/icons/bookmarkadd.svg';
import bookmarked from '../../../assets/icons/bookmarked.svg';
import border from '../../../assets/icons/border.svg';
import brand from '../../../assets/icons/brand.svg';
import brief from '../../../assets/icons/brief.svg';
import brightcove from '../../../assets/icons/brightcove.svg';
import brightcovedef from '../../../assets/icons/brightcovedef.svg';
import broadcast from '../../../assets/icons/broadcast.svg';
import brokenlink from '../../../assets/icons/brokenlink.svg';
import bulletlist from '../../../assets/icons/bulletlist.svg';
import bulletnumeric from '../../../assets/icons/bulletnumeric.svg';
import burnin from '../../../assets/icons/burnin.svg';
import camera from '../../../assets/icons/camera.svg';
import cameraswitch from '../../../assets/icons/cameraswitch.svg';
import captions from '../../../assets/icons/captions.svg';
import captureall from '../../../assets/icons/captureall.svg';
import captureapp from '../../../assets/icons/captureapp.svg';
import castforeducation from '../../../assets/icons/castforeducation.svg';
import capturescreen from '../../../assets/icons/capturescreen.svg';
import castcolor from '../../../assets/icons/castcolor.svg';
import castdef from '../../../assets/icons/castdef.svg';
import castfull from '../../../assets/icons/castfull.svg';
import castoriginal from '../../../assets/icons/castoriginal.svg';
import chevrondown from '../../../assets/icons/chevrondown.svg';
import chevronleft from '../../../assets/icons/chevronleft.svg';
import chevronright from '../../../assets/icons/chevronright.svg';
import chevronup from '../../../assets/icons/chevronup.svg';
import chromakey from '../../../assets/icons/chromakey.svg';
import chromakey2 from '../../../assets/icons/chromakey2.svg';
import clipboard from '../../../assets/icons/clipboard.svg';
import close from '../../../assets/icons/close.svg';
import colour from '../../../assets/icons/colour.svg';
import comment from '../../../assets/icons/comment.svg';
import comments from '../../../assets/icons/comments.svg';
import company from '../../../assets/icons/company.svg';
import computer from '../../../assets/icons/computer.svg';
import contract from '../../../assets/icons/contract.svg';
import corrupt from '../../../assets/icons/corrupt.svg';
import credits from '../../../assets/icons/credits.svg';
import cuedef from '../../../assets/icons/cuedef.svg';
import cueoriginal from '../../../assets/icons/cueoriginal.svg';
import dashboard from '../../../assets/icons/dashboard.svg';
import datareport from '../../../assets/icons/datareport.svg';
import defscreen from '../../../assets/icons/defscreen.svg';
import desktop from '../../../assets/icons/desktop.svg';
import doc from '../../../assets/icons/doc.svg';
import document from '../../../assets/icons/document.svg';
import dot from '../../../assets/icons/dot.svg';
import download from '../../../assets/icons/download.svg';
import downloadlatest from '../../../assets/icons/downloadlatest.svg';
import dragindicator from '../../../assets/icons/dragindicator.svg';
import dropbox from '../../../assets/icons/dropbox.svg';
import dropboxmono from '../../../assets/icons/dropboxmono.svg';
import duplicate from '../../../assets/icons/duplicate.svg';
import edit from '../../../assets/icons/edit.svg';
import editing from '../../../assets/icons/editing.svg';
import effects from '../../../assets/icons/effects.svg';
import elevatecolor from '../../../assets/icons/elevatecolor.svg';
import elevatedef from '../../../assets/icons/elevatedef.svg';
import elevateoriginal from '../../../assets/icons/elevateoriginal.svg';
import email from '../../../assets/icons/email.svg';
import email2 from '../../../assets/icons/email2.svg';
import embed from '../../../assets/icons/embed.svg';
import exit from '../../../assets/icons/exit.svg';
import exclamation from '../../../assets/icons/exclamation.svg';
import expand from '../../../assets/icons/expand.svg';
import exportI from '../../../assets/icons/export.svg';
import extrafootage from '../../../assets/icons/extrafootage.svg';
import facebook from '../../../assets/icons/facebook.svg';
import facebook2 from '../../../assets/icons/facebook2.svg';
import facebookdef from '../../../assets/icons/facebookdef.svg';
import faq from '../../../assets/icons/faq.svg';
import fastforward from '../../../assets/icons/fastforward.svg';
import favempty from '../../../assets/icons/favempty.svg';
import favfull from '../../../assets/icons/favfull.svg';
import favourite from '../../../assets/icons/favourite.svg';
import favouriteempty from '../../../assets/icons/favouriteempty.svg';
import fetcherror from '../../../assets/icons/fetcherror.svg';
import fill from '../../../assets/icons/fill.svg';
import finished from '../../../assets/icons/finished.svg';
import financereports from '../../../assets/icons/financereports.svg';
import flagar from '../../../assets/icons/flagar.svg';
import flagaus from '../../../assets/icons/flagaus.svg';
import flagbr from '../../../assets/icons/flagbr.svg';
import flagcs from '../../../assets/icons/flagcs.svg';
import flagde from '../../../assets/icons/flagde.svg';
import flages from '../../../assets/icons/flages.svg';
import flageuro from '../../../assets/icons/flageuro.svg';
import flagfr from '../../../assets/icons/flagfr.svg';
import flagit from '../../../assets/icons/flagit.svg';
import flagja from '../../../assets/icons/flagja.svg';
import flagko from '../../../assets/icons/flagko.svg';
import flagnl from '../../../assets/icons/flagnl.svg';
import flagpl from '../../../assets/icons/flagpl.svg';
import flagpt from '../../../assets/icons/flagpt.svg';
import flagru from '../../../assets/icons/flagru.svg';
import flagsg from '../../../assets/icons/flagsg.svg';
import flagtr from '../../../assets/icons/flagtr.svg';
import flaguae from '../../../assets/icons/flaguae.svg';
import flaguk from '../../../assets/icons/flaguk.svg';
import flagus from '../../../assets/icons/flagus.svg';
import flagzh from '../../../assets/icons/flagzh.svg';
import flashoff from '../../../assets/icons/flashoff.svg';
import flashon from '../../../assets/icons/flashon.svg';
import folder from '../../../assets/icons/folder.svg';
import forward10 from '../../../assets/icons/forward10.svg';
import forward102 from '../../../assets/icons/forward102.svg';
import formatcolortext from '../../../assets/icons/formatcolortext.svg';
import fullscreen from '../../../assets/icons/fullscreen.svg';
import fusedef from '../../../assets/icons/fusedef.svg';
import fuseoriginal from '../../../assets/icons/fuseoriginal.svg';
import ghost from '../../../assets/icons/ghost.svg';
import google from '../../../assets/icons/google.svg';
import googledef from '../../../assets/icons/googledef.svg';
import googledrive from '../../../assets/icons/googledrive.svg';
import grid from '../../../assets/icons/grid.svg';
import group from '../../../assets/icons/group.svg';
import group2 from '../../../assets/icons/group2.svg';
import guide from '../../../assets/icons/guide.svg';
import hd from '../../../assets/icons/hd.svg';
import hide from '../../../assets/icons/hide.svg';
import home from '../../../assets/icons/home.svg';
import hourglass from '../../../assets/icons/hourglass.svg';
import hourglassbottom from '../../../assets/icons/hourglassbottom.svg';
import hyperlink from '../../../assets/icons/hyperlink.svg';
import image from '../../../assets/icons/image.svg';
import importI from '../../../assets/icons/import.svg';
import info from '../../../assets/icons/info.svg';
import insights from '../../../assets/icons/insights.svg';
import inspiration from '../../../assets/icons/inspiration.svg';
import intaccess from '../../../assets/icons/intaccess.svg';
import italic from '../../../assets/icons/italic.svg';
import kazam from '../../../assets/icons/kazam.svg';
import label from '../../../assets/icons/label.svg';
import language from '../../../assets/icons/language.svg';
import largetext from '../../../assets/icons/largetext.svg';
import learning from '../../../assets/icons/learning.svg';
import library from '../../../assets/icons/library.svg';
import lightbulb from '../../../assets/icons/lightbulb.svg';
import link from '../../../assets/icons/link.svg';
import linkedin from '../../../assets/icons/linkedin.svg';
import linkedin2 from '../../../assets/icons/linkedin2.svg';
import linkedindef from '../../../assets/icons/linkedindef.svg';
import linkext from '../../../assets/icons/linkext.svg';
import list from '../../../assets/icons/list.svg';
import livechat from '../../../assets/icons/livechat.svg';
import location from '../../../assets/icons/location.svg';
import logo from '../../../assets/icons/logo.svg';
import logos from '../../../assets/icons/logos.svg';
import longform2 from '../../../assets/icons/longform2.svg';
import longertext from '../../../assets/icons/longertext.svg';
import mail from '../../../assets/icons/mail.svg';
import master from '../../../assets/icons/master.svg';
import musicnote from '../../../assets/icons/musicnote.svg';
import maximum from '../../../assets/icons/maximum.svg';
import medialibrary from '../../../assets/icons/medialibrary.svg';
import mediareport from '../../../assets/icons/mediareport.svg';
import menucol from '../../../assets/icons/menucol.svg';
import menuexp from '../../../assets/icons/menuexp.svg';
import microsoftcolor from '../../../assets/icons/microsoftcolor.svg';
import microsoftdef from '../../../assets/icons/microsoftdef.svg';
import minimum from '../../../assets/icons/minimum.svg';
import missing from '../../../assets/icons/missing.svg';
import mobile from '../../../assets/icons/mobile.svg';
import mobilemenu from '../../../assets/icons/mobilemenu.svg';
import monitor from '../../../assets/icons/monitor.svg';
import move from '../../../assets/icons/move.svg';
import negative from '../../../assets/icons/negative.svg';
import nocomments from '../../../assets/icons/nocomments.svg';
import notes from '../../../assets/icons/notes.svg';
import notes2 from '../../../assets/icons/notes2.svg';
import notifications from '../../../assets/icons/notifications.svg';
import options from '../../../assets/icons/options.svg';
import orgadmin from '../../../assets/icons/orgadmin.svg';
import organisation from '../../../assets/icons/organisation.svg';
import packageI from '../../../assets/icons/package.svg';
import padlock from '../../../assets/icons/padlock.svg';
import partial from '../../../assets/icons/partial.svg';
import pause from '../../../assets/icons/pause.svg';
import payg from '../../../assets/icons/payg.svg';
import pdf from '../../../assets/icons/pdf.svg';
import phone from '../../../assets/icons/phone.svg';
import platinum from '../../../assets/icons/platinum.svg';
import play from '../../../assets/icons/play.svg';
import podcast from '../../../assets/icons/podcast.svg';
import podcastproject from '../../../assets/icons/podcastproject.svg';
import podcasts from '../../../assets/icons/podcasts.svg';
import portrait from '../../../assets/icons/portrait.svg';
import positive from '../../../assets/icons/positive.svg';
import ppt from '../../../assets/icons/ppt.svg';
import preferences from '../../../assets/icons/preferences.svg';
import previous from '../../../assets/icons/previous.svg';
import prevpage from '../../../assets/icons/prevpage.svg';
import procolor from '../../../assets/icons/procolor.svg';
import prodef from '../../../assets/icons/prodef.svg';
import proeditcolor from '../../../assets/icons/proeditcolor.svg';
import proeditdef from '../../../assets/icons/proeditdef.svg';
import professional from '../../../assets/icons/professional.svg';
import projects from '../../../assets/icons/projects.svg';
import prooriginal from '../../../assets/icons/prooriginal.svg';
import publish from '../../../assets/icons/publish.svg';
import qrcode from '../../../assets/icons/qrcode.svg';
import queue from '../../../assets/icons/queue.svg';
import quoteleft from '../../../assets/icons/quoteleft.svg';
import quoteright from '../../../assets/icons/quoteright.svg';
import raceflag from '../../../assets/icons/raceflag.svg';
import recent from '../../../assets/icons/recent.svg';
import recommended from '../../../assets/icons/recommended.svg';
import record from '../../../assets/icons/record.svg';
import recordvoiceover from '../../../assets/icons/recordvoiceover.svg';
import redo from '../../../assets/icons/redo.svg';
import refresh from '../../../assets/icons/refresh.svg';
import remove from '../../../assets/icons/remove.svg';
import replace from '../../../assets/icons/replace.svg';
import reply from '../../../assets/icons/reply.svg';
import report from '../../../assets/icons/report.svg';
import returnI from '../../../assets/icons/return.svg';
import rewind from '../../../assets/icons/rewind.svg';
import rewind10 from '../../../assets/icons/rewind10.svg';
import rewind102 from '../../../assets/icons/rewind102.svg';
import robot from '../../../assets/icons/robot.svg';
import rollover from '../../../assets/icons/rollover.svg';
import runningman from '../../../assets/icons/runningman.svg';
import rushedit from '../../../assets/icons/rushedit.svg';
import rushsuper from '../../../assets/icons/rushsuper.svg';
import script from '../../../assets/icons/script.svg';
import sd from '../../../assets/icons/sd.svg';
import search from '../../../assets/icons/search.svg';
import send from '../../../assets/icons/send.svg';
import settings2 from '../../../assets/icons/settings2.svg';
import share from '../../../assets/icons/share.svg';
import share2 from '../../../assets/icons/share2.svg';
import shootstacolour from '../../../assets/icons/shootstacolour.svg';
import shootstadef from '../../../assets/icons/shootstadef.svg';
import shootstagrad from '../../../assets/icons/shootstagrad.svg';
import shootstagrad2 from '../../../assets/icons/shootstagrad2.svg';
import shorttext from '../../../assets/icons/shorttext.svg';
import shot from '../../../assets/icons/shot.svg';
import show from '../../../assets/icons/show.svg';
import shutterstock from '../../../assets/icons/shutterstock.svg';
import sizeblank from '../../../assets/icons/sizeblank.svg';
import sizedef from '../../../assets/icons/sizedef.svg';
import skip from '../../../assets/icons/skip.svg';
import smalltext from '../../../assets/icons/smalltext.svg';
import smallchevrondown from '../../../assets/icons/smallchevrondown.svg';
import smallchevronup from '../../../assets/icons/smallchevronup.svg';
import social from '../../../assets/icons/social.svg';
import sort from '../../../assets/icons/sort.svg';
import sparkle from '../../../assets/icons/sparkle.svg';
import speakermax from '../../../assets/icons/speakermax.svg';
import speakermin from '../../../assets/icons/speakermin.svg';
import speakermute from '../../../assets/icons/speakermute.svg';
import speedx10 from '../../../assets/icons/speedx10.svg';
import speedx15 from '../../../assets/icons/speedx15.svg';
import speedx20 from '../../../assets/icons/speedx20.svg';
import splash from '../../../assets/icons/splash.svg';
import square from '../../../assets/icons/square.svg';
import standard from '../../../assets/icons/standard.svg';
import statistics from '../../../assets/icons/statistics.svg';
import stop from '../../../assets/icons/stop.svg';
import storyboard from '../../../assets/icons/storyboard.svg';
import subscription from '../../../assets/icons/subscription.svg';
import subtitle from '../../../assets/icons/subtitle.svg';
import success from '../../../assets/icons/success.svg';
import sync from '../../../assets/icons/sync.svg';
import sync2 from '../../../assets/icons/sync2.svg';
import tabcollapse from '../../../assets/icons/tabcollapse.svg';
import tabexpand from '../../../assets/icons/tabexpand.svg';
import tablet from '../../../assets/icons/tablet.svg';
import tags from '../../../assets/icons/tags.svg';
import teamadmin from '../../../assets/icons/teamadmin.svg';
import telealignbottom from '../../../assets/icons/telealignbottom.svg';
import telealignleft from '../../../assets/icons/telealignleft.svg';
import telealignright from '../../../assets/icons/telealignright.svg';
import telealigntop from '../../../assets/icons/telealigntop.svg';
import template from '../../../assets/icons/template.svg';
import template2 from '../../../assets/icons/template2.svg';
import thumbdown from '../../../assets/icons/thumbdown.svg';
import thumbup from '../../../assets/icons/thumbup.svg';
import tipsandhint from '../../../assets/icons/tipsandhint.svg';
import transcribe from '../../../assets/icons/transcribe.svg';
import trash from '../../../assets/icons/trash.svg';
import trashclosed from '../../../assets/icons/trashclosed.svg';
import trophy from '../../../assets/icons/trophy.svg';
import twentythree from '../../../assets/icons/twentythree.svg';
import twentythreedef from '../../../assets/icons/twentythreedef.svg';
import twitter from '../../../assets/icons/twitter.svg';
import twitter2 from '../../../assets/icons/twitter2.svg';
import txt from '../../../assets/icons/txt.svg';
import txtcolor from '../../../assets/icons/txtcolor.svg';
import typography from '../../../assets/icons/typography.svg';
import underline from '../../../assets/icons/underline.svg';
import undo from '../../../assets/icons/undo.svg';
import unlimited from '../../../assets/icons/unlimited.svg';
import unlock from '../../../assets/icons/unlock.svg';
import unsupported from '../../../assets/icons/unsupported.svg';
import upload from '../../../assets/icons/upload.svg';
import uploadfile from '../../../assets/icons/uploadfile.svg';
import user from '../../../assets/icons/user.svg';
import video from '../../../assets/icons/video.svg';
import videocamera from '../../../assets/icons/videocamera.svg';
import videocam from '../../../assets/icons/videocam.svg';
import videoproject from '../../../assets/icons/videoproject.svg';
import vidres from '../../../assets/icons/vidres.svg';
import vidtitle from '../../../assets/icons/vidtitle.svg';
import vidyard from '../../../assets/icons/vidyard.svg';
import vidyarddef from '../../../assets/icons/vidyarddef.svg';
import vimeo from '../../../assets/icons/vimeo.svg';
import vimeodef from '../../../assets/icons/vimeodef.svg';
import vodcast from '../../../assets/icons/vodcast.svg';
import voiceover from '../../../assets/icons/voiceover.svg';
import web from '../../../assets/icons/web.svg';
import webcam from '../../../assets/icons/webcam.svg';
import webcamoff from '../../../assets/icons/webcamoff.svg';
import webinarproject from '../../../assets/icons/webinarproject.svg';
import widescreen from '../../../assets/icons/widescreen.svg';
import wistia from '../../../assets/icons/wistia.svg';
import wistiadef from '../../../assets/icons/wistiadef.svg';
import wordcount from '../../../assets/icons/wordcount.svg';
import xls from '../../../assets/icons/xls.svg';
import youtube from '../../../assets/icons/youtube.svg';
import youtubedef from '../../../assets/icons/youtubedef.svg';
import filedownload from '../../../assets/icons/filedownload.svg';
import feedback from '../../../assets/icons/feedback.svg';
import checkcircleoutline from '../../../assets/icons/checkcircleoutline.svg';
import line from '../../../assets/icons/line.svg';
import hubspot from '../../../assets/icons/hubspot.svg';
import checkedFilled from '../../../assets/icons/checkedFilled.svg';
import ondemandvideo from '../../../assets/icons/ondemandvideo.svg';

import reportsV2 from '../../../assets/icons/reportsV2.svg';
import livechatV2 from '../../../assets/icons/livechatV2.svg';
import helpV2 from '../../../assets/icons/helpV2.svg';
import systemV2 from '../../../assets/icons/systemV2.svg';
import trafficV2 from '../../../assets/icons/trafficV2.svg';
import exitV2 from '../../../assets/icons/exitV2.svg';
import clientsV2 from '../../../assets/icons/clientsV2.svg';
import libraryV2 from '../../../assets/icons/libraryV2.svg';
import removecircleoutline from '../../../assets/icons/removecircleoutline.svg';
import gridview from '../../../assets/icons/gridview.svg';
import zoomout from '../../../assets/icons/zoomout.svg';
import supervisor from '../../../assets/icons/supervisor.svg';
import zoomin from '../../../assets/icons/zoomin.svg';
import suitcase from '../../../assets/icons/suitcase.svg';
import umbrella from '../../../assets/icons/umbrella.svg';
import volumeup from '../../../assets/icons/volumeup.svg';
import media from '../../../assets/icons/media.svg';
import contentcopy from '../../../assets/icons/contentcopy.svg';
import deleteicon from '../../../assets/icons/deleteicon.svg';

export default {
  checkedFilled,
  activity,
  line,
  addcomment,
  addcomment2,
  addfat,
  addfolder,
  addons,
  addthin,
  admin,
  adobe,
  alert,
  aligncenter,
  alignjustified,
  alignleft,
  alignright,
  animation,
  animationproject,
  apple,
  apps,
  archive,
  arrowdown,
  arrowleft,
  arrowright,
  arrowup,
  article,
  aspectratio,
  aspectshell,
  at,
  attachment,
  audio,
  autocue,
  autosave,
  backhand,
  blockquote,
  bold,
  bookings,
  bookingsdef,
  bookmark,
  bookmarkadd,
  bookmarked,
  border,
  brand,
  brief,
  brightcove,
  brightcovedef,
  broadcast,
  brokenlink,
  bulletlist,
  bulletnumeric,
  burnin,
  camera,
  cameraswitch,
  captions,
  captureall,
  captureapp,
  castforeducation,
  capturescreen,
  castcolor,
  castdef,
  castfull,
  castoriginal,
  chevrondown,
  chevronleft,
  chevronright,
  chevronup,
  chromakey,
  chromakey2,
  clipboard,
  close,
  colour,
  comment,
  comments,
  company,
  computer,
  contract,
  corrupt,
  credits,
  cuedef,
  cueoriginal,
  dashboard,
  datareport,
  defscreen,
  desktop,
  doc,
  document,
  dot,
  download,
  downloadlatest,
  dragindicator,
  dropbox,
  dropboxmono,
  duplicate,
  edit,
  editing,
  effects,
  elevatecolor,
  elevatedef,
  elevateoriginal,
  email,
  email2,
  embed,
  exit,
  exclamation,
  expand,
  exportI,
  extrafootage,
  facebook,
  facebook2,
  facebookdef,
  faq,
  fastforward,
  favempty,
  favfull,
  favourite,
  favouriteempty,
  fetcherror,
  fill,
  financereports,
  finished,
  flagar,
  flagaus,
  flagbr,
  flagcs,
  flagde,
  flages,
  flageuro,
  flagfr,
  flagit,
  flagja,
  flagko,
  flagnl,
  flagpl,
  flagpt,
  flagru,
  flagsg,
  flagtr,
  flaguae,
  flaguk,
  flagus,
  flagzh,
  flashoff,
  flashon,
  folder,
  forward10,
  forward102,
  formatcolortext,
  fullscreen,
  fusedef,
  fuseoriginal,
  ghost,
  google,
  googledef,
  googledrive,
  grid,
  group,
  group2,
  guide,
  hd,
  hide,
  home,
  hourglass,
  hourglassbottom,
  hyperlink,
  image,
  importI,
  info,
  insights,
  inspiration,
  intaccess,
  italic,
  kazam,
  label,
  language,
  largetext,
  learning,
  library,
  lightbulb,
  link,
  linkedin,
  linkedin2,
  linkedindef,
  linkext,
  list,
  livechat,
  location,
  logo,
  logos,
  longform2,
  mail,
  master,
  maximum,
  medialibrary,
  mediareport,
  menucol,
  menuexp,
  microsoftcolor,
  microsoftdef,
  minimum,
  missing,
  mobile,
  mobilemenu,
  monitor,
  move,
  musicnote,
  negative,
  nocomments,
  notes,
  notes2,
  notifications,
  options,
  orgadmin,
  organisation,
  packageI,
  padlock,
  partial,
  pause,
  payg,
  pdf,
  phone,
  platinum,
  play,
  podcast,
  podcastproject,
  podcasts,
  portrait,
  positive,
  ppt,
  preferences,
  previous,
  prevpage,
  procolor,
  prodef,
  proeditcolor,
  proeditdef,
  professional,
  projects,
  prooriginal,
  publish,
  qrcode,
  queue,
  quoteleft,
  quoteright,
  raceflag,
  recent,
  recommended,
  record,
  recordvoiceover,
  redo,
  refresh,
  remove,
  replace,
  reply,
  report,
  returnI,
  rewind,
  rewind10,
  rewind102,
  robot,
  rollover,
  runningman,
  rushedit,
  rushsuper,
  script,
  sd,
  search,
  send,
  settings2,
  share,
  share2,
  shootstacolour,
  shootstadef,
  shootstagrad,
  shootstagrad2,
  shot,
  show,
  shutterstock,
  sizeblank,
  sizedef,
  skip,
  smalltext,
  smallchevronup,
  smallchevrondown,
  social,
  sort,
  sparkle,
  speakermax,
  speakermin,
  speakermute,
  speedx10,
  speedx15,
  speedx20,
  splash,
  square,
  standard,
  statistics,
  stop,
  storyboard,
  subscription,
  subtitle,
  success,
  sync,
  sync2,
  tabcollapse,
  tabexpand,
  tablet,
  tags,
  teamadmin,
  telealignbottom,
  telealignleft,
  telealignright,
  telealigntop,
  template,
  template2,
  thumbdown,
  thumbup,
  tipsandhint,
  transcribe,
  trash,
  trashclosed,
  trophy,
  twentythree,
  twentythreedef,
  twitter,
  twitter2,
  txt,
  txtcolor,
  typography,
  underline,
  undo,
  unlimited,
  unlock,
  unsupported,
  upload,
  uploadfile,
  user,
  video,
  videocamera,
  videocam,
  videoproject,
  vidres,
  vidtitle,
  vidyard,
  vidyarddef,
  vimeo,
  vimeodef,
  vodcast,
  voiceover,
  web,
  webcam,
  webcamoff,
  webinarproject,
  widescreen,
  wistia,
  wistiadef,
  wordcount,
  xls,
  youtube,
  youtubedef,
  filedownload,
  feedback,
  shorttext,
  longertext,
  beachaccess,
  checkcircleoutline,
  hubspot,
  ondemandvideo,
  reportsV2,
  livechatV2,
  helpV2,
  systemV2,
  trafficV2,
  exitV2,
  clientsV2,
  libraryV2,
  removecircleoutline,
  gridview,
  zoomout,
  supervisor,
  zoomin,
  suitcase,
  umbrella,
  volumeup,
  media,
  contentcopy,
  deleteicon
};